// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__1dG9x","mobile":"style_mobile__zu3Mf","laptop":"style_laptop__wShkJ","small":"style_small__3-uoO","v3":"style_v3__7UXG3"};